import styled, { css } from 'styled-components';

import { colors, media, Theme } from '../../../core';
import Icon from '../Icon';
import Label from '../Label';
import Text from '../Text';

export const baseSmallLabelStyles = css`
  ${({ theme }) => `
    font-size: 12px;
    top: 0;
    color: ${theme.fontColor || colors.ash};
  `}
`;

export const StyledIcon = styled(Icon).attrs(({ theme, color }) => ({
  color: color ? color : theme.selectIndicatorIconColor || colors.primary,
}))`
  margin-top: 0;
  cursor: pointer;
`;

export const SelectInputLayout = styled.div<{ width?: string; hasEnteredText: boolean }>`
  width: ${({ width }) => width || '100%'};
  position: relative;

  ${media.tabletPortrait} {
    width: 100%;
  }

  ${({ hasEnteredText }) =>
    hasEnteredText &&
    css`
      ${AnimatedLabel} {
        ${baseSmallLabelStyles};
      }
    `}
`;

export const StyledLabel = styled(Label)<{
  labelType?: 'outside' | 'inside';
  variant?: 'primary' | 'secondary' | 'tertiary';
}>`
  ${({ labelType, variant, theme }) =>
    labelType === 'outside' &&
    variant === 'tertiary' &&
    theme.name !== Theme.theme1 &&
    `
      font-size: 12px;
      font-weight: 400;
      padding: 0 16px;
      margin: 0;
      position: absolute;
      top: -8px;
      line-height: 1.5;
  `}

  ${({ labelType, variant }) =>
    labelType === 'inside' &&
    variant === 'secondary' &&
    `
      position: absolute;
      top: 7px;
      left: 20px;
      width: 80px;
      margin: 0;
      line-height: 1.5;

      ${media.tabletPortrait} {
        left: 12px;
        top: 12px;
      }
  `}
`;

export const AnimatedLabel = styled(Label)`
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;
  line-height: 2;
  transition: top 300ms ease-in-out, font-size 300ms ease-in-out, opacity 300ms ease-in-out;
  color: ${({ theme }) => theme.textInputColor || colors.ash};
  z-index: -1;
`;

export const StyledOptionContainer = styled.div<{ isFocused?: boolean }>`
  align-items: center;
  background-color: ${({ isFocused }) => (isFocused ? colors.pearl : colors.white)};
  display: flex;
  justify-content: space-between;
  padding-right: 5px;
`;

export const CheckboxWrapper = styled.div`
  padding: 8px 0;
`;

export const ErrorMessage = styled(Text)`
  margin: 0;
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.errorColor};
  padding: ${({ theme }) => theme.inputErrorMessagePadding || '0'};
  line-height: 1.5;
`;
